const t = "styles-module__modal_overlay___J0MtT", _ = "styles-module__content___gvGld", o = "styles-module__header___2UrO1", e = "styles-module__title_container___d9uL0", n = "styles-module__close_button___ugGbx", s = "styles-module__icon_container___f-y6y", l = "styles-module__title___QRRcl", c = "styles-module__description___ScYO-", i = "styles-module__actions___E2KlS", a = "styles-module__action_button___eHbOU", d = "styles-module__button_secondary___hk7U2", u = {
  modal_overlay: t,
  content: _,
  header: o,
  title_container: e,
  close_button: n,
  icon_container: s,
  title: l,
  description: c,
  actions: i,
  action_button: a,
  button_secondary: d
};
export {
  a as action_button,
  i as actions,
  d as button_secondary,
  n as close_button,
  _ as content,
  u as default,
  c as description,
  o as header,
  s as icon_container,
  t as modal_overlay,
  l as title,
  e as title_container
};
